import { render, staticRenderFns } from "./footbar.vue?vue&type=template&id=22df7258&scoped=true&"
import script from "./footbar.vue?vue&type=script&lang=js&"
export * from "./footbar.vue?vue&type=script&lang=js&"
import style0 from "./footbar.vue?vue&type=style&index=0&id=22df7258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df7258",
  null
  
)

export default component.exports